/** Angular `versionUpdateTime` */
export const VERSION_POLL_MS = 300_000
/** Angular auto-refresh window */
export const COUNTDOWN_SECONDS = 300
export const VERSION_STORAGE_KEY = 'app_versionid'
